import React from 'react';
import styles from './styles.module.scss'
import classNames from "classnames";
import {BodyTitleText} from "@/app/components/texts";

interface IconImageProps {
  asset?: string;
  alt?: string;
  className?: string | undefined;
  classNameForContainer?: string | undefined;
  onClick?: () => void
  disabled?: boolean
  icon?: React.ReactNode
  text?: string
}

const IconButton: React.FC<IconImageProps> = ({
                                                asset,
                                                alt,
                                                className,
                                                classNameForContainer,
                                                onClick,
                                                disabled,
                                                icon,
                                                text
                                              }) => {
  return (
    <div className={classNames(styles.button, classNameForContainer, {[styles.hasText]: text})} onClick={disabled ? undefined : onClick}>
      {icon || <img className={classNames(styles.icon, className)} src={asset} alt={alt}/>} {text &&
        <BodyTitleText text={text} className={styles.text}/>}</div>);
}

export default IconButton;